export const isValidTracklistUrl = (url) => {
  if (url === null) return false;
  const supportedUrls = ['1001tracklists.com', 'setlist.fm', 'livetracklist.com', 'mixesdb.com'];
  return supportedUrls.some(
    supportedUrl => url.toLowerCase().includes(supportedUrl)
  );
};
